// extracted by mini-css-extract-plugin
export var productImage = "_qs-1";
export var viewLink = "_qs-2";
export var wishlistItem = "_qs-0";